import { useQuery } from "@apollo/client/react";

import { SEARCH_AZURE_INTEGRATIONS } from "./gql";

const useSearchAzureIntegrations = () => {
  const { loading, error, data } = useQuery(SEARCH_AZURE_INTEGRATIONS);

  return {
    integrations: data?.azureIntegrations || [],
    error,
    isPageLoading: loading && !data,
  };
};

export default useSearchAzureIntegrations;
